import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser'; 
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { ArrowRight, ChevronDown, ChevronLeft, ChevronRight, Activity, Zap, MapPin, Menu, X, Instagram, Linkedin, Facebook, CheckCircle, AlertCircle, Loader2, Truck, Wrench, Building2, ShieldCheck, Plus, XCircle, BatteryCharging } from 'lucide-react';

// --- DATA ---
const projects = [
  // EJECUTADOS
  {
    id: 1,
    title: "Creación de SET Catacaos 15 MVA y Enlaces en MT",
    category: "Contratos Ejecutados",
    video: "https://aden.afygroup.net/CLIP%2011.mp4",
    desc: "Creación de SET Catacaos 15 MVA y Enlaces en MT a Alimentadores Existentes, Distrito de Catacaos, Provincia de Piura – Departamento de Piura."
  },
  {
    id: 2,
    title: "Implementación Transformador 15 MVA SET Huancayo Este",
    category: "Contratos Ejecutados",
    video: "https://aden.afygroup.net/CLIP%2013.mp4",
    desc: "Implementación de transformador 15 MVA en la Subestación Huancayo Este y una bahía en 60 KV de llegada a la Subestación Parque Industrial, con su línea en 60 KV de interconexión para cierre en anillo, Junín."
  },
  {
    id: 3,
    title: "Salidas en 60 KV de la SET Orcotuna a Concepción - Jauja",
    category: "Contratos Ejecutados",
    video: "https://aden.afygroup.net/CLIP%2010.mp4",
    desc: "Saldo de Obra: Creación (Enlace PI) dos salidas en 60 KV de la SET ORCOTUNA a CONCEPCIÓN – JAUJA y al Parque Industrial Distrito de Orcotuna, Junín."
  },
  {
    id: 4,
    title: "Renovación Celda de Línea y Transformador SET Chiclayo Oeste",
    category: "Contratos Ejecutados",
    video: "https://aden.afygroup.net/CLIP%201.mp4",
    desc: "Contrato de Obra GR-026-2025: Renovación de celda de línea y celda de transformador; en la línea L-6012 y L-6022 y en el transformador TP-6002 de la SET Chiclayo Oeste, Lambayeque."
  },
  // EN EJECUCIÓN
  {
    id: 5,
    title: "Ampliación L.T. 138 KV Trujillo Norte - Nor Oeste",
    category: "Contratos en Ejecución",
    video: "https://aden.afygroup.net/CLIP%202.mp4",
    desc: "Contrato de ejecución de obra GA/L-051-2025: Ampliación de Línea de Transmisión 138 KV, SET Trujillo Norte - SET Trujillo Nor Oeste, La Libertad."
  },
  {
    id: 6,
    title: "Sistema de Utilización en MT 10KV proyectado a 22.9KV",
    category: "Contratos en Ejecución",
    video: "https://aden.afygroup.net/CLIP%203.mp4",
    desc: "Obra: Sistema de utilización en MT 10KV proyectado a 22.9KV para el plantel de engorde Chiquitoy de la empresa Chimú Agropecuaria S.A., La Libertad."
  },
  {
    id: 7,
    title: "Liberación de Interferencias Eléctricas Autopista El Sol",
    category: "Contratos en Ejecución",
    video: "https://aden.afygroup.net/CLIP%2011.mp4",
    desc: "Obra: Liberación de interferencias eléctricas constituidas por redes eléctricas de Media y Baja Tensión que interfieren con la construcción del tramo KM 778 al KM 795 del evitamiento Chiclayo."
  },
  {
    id: 8,
    title: "Ampliación Distribución Primaria Rinconada Llícuar",
    category: "Contratos en Ejecución",
    video: "https://aden.afygroup.net/CLIP%2013.mp4",
    desc: "Reforzamiento y ampliación de distribución primaria 10-22.9 kV y subsistema de distribución secundaria 380/220 V para las localidades de Rinconada, Dos Pueblos, CP Llícuar, Sechura, Piura."
  },
  // ADJUDICADOS
  {
    id: 9,
    title: "Mejoramiento y Ampliación SE Tomasiri 66/22.9/10 kV",
    category: "Contratos Adjudicados",
    video: "https://aden.afygroup.net/CLIP%2010.mp4",
    desc: "Mejoramiento y ampliación de la SE Tomasiri 66/22.9/10 kV, Distrito de Sama – Provincia de Tacna – Departamento de Tacna."
  },
  {
    id: 10,
    title: "Renovación Suministro de Energía Av. Grau - Piura",
    category: "Contratos Adjudicados",
    video: "https://aden.afygroup.net/CLIP%201.mp4",
    desc: "Renovación del suministro de energía eléctrica; en las zonas urbanas de la Avenida Grau y Prolongación de la Av. Grau, Distrito de Piura y Veintiséis de Octubre."
  },
  {
    id: 11,
    title: "Ampliación SET Caraz - Nuevo Transformador",
    category: "Contratos Adjudicados",
    video: "https://aden.afygroup.net/CLIP%202.mp4",
    desc: "Ampliación de la SET Caraz con la instalación del nuevo transformador de potencia 66/22.9/13.8/10 KV, 15 MVA, celdas de transformador, medición y alimentador, Ancash."
  },
  {
    id: 12,
    title: "Ampliación SET Carhuaz - Transformador y Rotado",
    category: "Contratos Adjudicados",
    video: "https://aden.afygroup.net/CLIP%203.mp4",
    desc: "Ampliación de la SET Carhuaz con la instalación del transformador 9/5/7/3 MVA - 66/22.9/13.8/10 KV, rotado de la SET Ticapampa, Ancash."
  },
  {
    id: 13,
    title: "Ampliación Capacidad de Transformación SET Chulucanas",
    category: "Contratos Adjudicados",
    video: "https://aden.afygroup.net/CLIP%2011.mp4",
    desc: "Ampliación de la capacidad de transformación en SET Chulucanas, Distrito de Chulucanas, Provincia de Morropón, Departamento de Piura."
  }
];

const divisions = [
  { 
    id: "obras",
    icon: Building2, 
    title: "Obras Eléctricas", 
    text: "Diseño y ejecución de proyectos en alta, media y baja tensión.",
    details: [
      "Diseño y ejecución de proyectos eléctricos en alta tensión.",
      "Diseño y ejecución de proyectos eléctricos en media y baja tensión.",
      "Desarrollo integral de Subestaciones de Transformación (SET).",
      "Construcción y ampliación de Líneas de Transmisión."
    ]
  },
  { 
    id: "servicios",
    icon: Wrench, 
    title: "Servicios y Mantenimiento", 
    text: "Mantenimiento predictivo, preventivo y correctivo, y análisis especializados.",
    details: [
      "Mantenimiento eléctrico predictivo, preventivo y correctivo.",
      "Análisis de rigidez dieléctrica.",
      "Estudios y auditorías para el ahorro de energía.",
      "Atención de emergencias y soporte técnico especializado."
    ]
  },
  { 
    id: "proteccion",
    icon: ShieldCheck, 
    title: "Ingeniería de Protección", 
    text: "Diseño e implementación integral de sistemas de protección eléctrica.",
    details: [
      "Diseño e implementación de sistemas de protección eléctrica.",
      "Sistemas de puesta a tierra.",
      "Coordinación de protecciones para la industria.",
      "Cumplimiento riguroso de normativas vigentes del CNE."
    ]
  },
];

const rentalItems = [
  {
    title: "Grupos Electrógenos",
    desc: "¿Su proyecto no puede permitirse un apagón? Nuestros grupos electrógenos garantizan energía ininterrumpida donde y cuando la necesite. Alquiler, venta e instalación con respaldo técnico 24/7.",
    specs: ["Desde 10 kW hasta 1000 kW (1 MW)", "Equipos insonorizados certificados", "Mantenimiento preventivo incluido en alquiler"],
    icon: BatteryCharging
  },
  {
    title: "Transformadores de Distribución",
    desc: "Entrega inmediata para evitar paradas costosas en su operación. Stock disponible de transformadores secos y en aceite, listos para instalar sin demoras ni contratiempos.",
    specs: ["Hasta 1000 kVA (1 MVA) de potencia", "Transformadores Secos para interiores", "Transformadores en Aceite para exteriores"],
    icon: Zap
  },
  {
    title: "Camiones Grúa Articulada",
    desc: "Izaje seguro y eficiente para maniobras donde el error no es opción. Operadores certificados, flota moderna y cobertura nacional para sus proyectos eléctricos más exigentes.",
    specs: ["Hasta 12 TN de capacidad de carga", "Operadores certificados y con experiencia", "Flota moderna con GPS y seguro activo"],
    icon: Truck
  }
];

const TYPING_WORDS = ["Carga y Energía", "Obras Eléctricas", "Soluciones Integrales", "Rental de Equipos"];
const HERO_VIDEOS = [
  "https://aden.afygroup.net/CLIP%201.mp4",
  "https://aden.afygroup.net/CLIP%202.mp4",
  "https://aden.afygroup.net/CLIP%203.mp4"
];

// --- COMPONENTS ---
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-slate-900/95 backdrop-blur-md py-4 shadow-lg border-b border-white/5' : 'bg-transparent py-8'}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <div className="flex items-center gap-2">
            <img src="/logo-aden.png" alt="ADEN Logo" className="h-12 md:h-14 w-auto object-contain transition-all duration-300 brightness-0 invert filter drop-shadow-md" />
        </div>
        <div className="hidden md:flex gap-8 text-sm font-medium tracking-wide">
          {['Nosotros', 'Soluciones', 'Rental', 'Proyectos'].map((item) => (
            <a key={item} href={`#${item.toLowerCase()}`} className="text-white/90 hover:text-yellow-400 transition-colors uppercase font-semibold drop-shadow-sm">
              {item}
            </a>
          ))}
        </div>
        <a href="#contacto" className="hidden md:flex items-center gap-2 bg-yellow-400 text-slate-900 px-6 py-2 rounded-full font-bold hover:bg-white hover:text-slate-900 transition-all duration-300 shadow-[0_0_15px_rgba(250,204,21,0.3)]">
          Contacto Directo <ArrowRight size={16} />
        </a>
        <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-white">
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="md:hidden bg-slate-900 border-t border-slate-800">
            <div className="flex flex-col p-6 gap-4">
               {['Nosotros', 'Soluciones', 'Rental', 'Proyectos', 'Contacto'].map((item) => (
                <a key={item} href={`#${item.toLowerCase()}`} onClick={() => setMobileOpen(false)} className="text-white text-lg font-medium">{item}</a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

const useTypewriter = (words, typingSpeed = 150, deletingSpeed = 100, pauseTime = 2000) => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [reverse, setReverse] = useState(false);
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const timeout2 = setTimeout(() => setBlink((prev) => !prev), 500);
    return () => clearTimeout(timeout2);
  }, [blink]);

  useEffect(() => {
    if (subIndex === words[index].length + 1 && !reverse) {
      const timeout = setTimeout(() => setReverse(true), pauseTime);
      return () => clearTimeout(timeout);
    }
    if (subIndex === 0 && reverse) {
      setReverse(false);
      setIndex((prev) => (prev + 1) % words.length);
      return;
    }
    const timeout = setTimeout(() => {
      setSubIndex((prev) => prev + (reverse ? -1 : 1));
    }, Math.max(reverse ? deletingSpeed : typingSpeed, parseInt(Math.random() * 50)));

    return () => clearTimeout(timeout);
  }, [subIndex, index, reverse, words, typingSpeed, deletingSpeed, pauseTime]);

  return `${words[index].substring(0, subIndex)}${blink ? "|" : " "}`;
};

const Hero = () => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 500], [0, 200]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRefs = useRef([]);
  const typingText = useTypewriter(TYPING_WORDS, 70, 40, 1200);

  useEffect(() => {
    if (videoRefs.current[0]) videoRefs.current[0].play().catch(e => console.log("Auto-play error", e));
  }, []);

  const handleVideoEnd = (index) => {
    const nextIndex = (index + 1) % HERO_VIDEOS.length;
    if (videoRefs.current[nextIndex]) {
        videoRefs.current[nextIndex].currentTime = 0;
        videoRefs.current[nextIndex].play().then(() => setCurrentVideoIndex(nextIndex)).catch(e => console.error("Error playing next video", e));
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden bg-slate-950">
      <motion.div style={{ y: y1 }} className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-slate-900 z-0">
             <img src="https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-50" alt="background"/>
        </div>
        {HERO_VIDEOS.map((src, index) => (
            <video key={src} ref={el => videoRefs.current[index] = el} src={src} muted playsInline onEnded={() => handleVideoEnd(index)} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${index === currentVideoIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} />
        ))}
      </motion.div>
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-slate-900/80 via-slate-900/40 to-slate-900" />
      <div className="absolute inset-0 z-10 opacity-20" style={{ backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>

      <div className="container mx-auto px-6 relative z-20 pt-20">
        <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut" }} className="max-w-4xl">
          <h2 className="text-yellow-400 font-bold tracking-widest text-sm mb-4 uppercase flex items-center gap-2">
            <span className="w-8 h-[2px] bg-yellow-400 inline-block"></span>
            Ingeniería Electromecánica Líder
          </h2>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-8 min-h-[140px] md:min-h-[180px]">
            Soluciones inmediatas en <br/><span className="text-yellow-400">{typingText}</span>
          </h1>
          <p className="text-white drop-shadow-md text-lg md:text-xl max-w-2xl font-normal leading-relaxed mb-10 border-l-2 border-yellow-400 pl-6">
            Garantizamos la continuidad, eficiencia y seguridad de sus operaciones con altos estándares de calidad e innovación tecnológica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
             <a href="#proyectos" className="px-8 py-4 bg-yellow-500 text-slate-900 font-bold text-lg rounded-sm hover:bg-yellow-400 transition-colors flex items-center justify-center gap-3">
                Ver Proyectos <ArrowRight size={20} />
             </a>
             <a href="#soluciones" className="px-8 py-4 border border-white/20 text-white font-medium text-lg rounded-sm hover:bg-white/10 transition-colors flex items-center justify-center">
                Nuestras Soluciones
             </a>
          </div>
        </motion.div>
      </div>
      <motion.div style={{ opacity: 1 }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 text-white flex flex-col items-center gap-2">
        <span className="text-xs uppercase tracking-widest text-slate-400">Descubre Más</span>
        <ChevronDown className="animate-bounce" />
      </motion.div>
    </section>
  );
};

const Stats = () => {
  return (
    <div className="bg-slate-900 py-16 border-b border-white/5 relative z-20">
      <div className="container mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
        {[
          { num: "24+", label: "Años de experiencia" },
          { num: "3", label: "Divisiones Operativas" },
          { num: "100%", label: "Cobertura Nacional" },
          { num: "24/7", label: "Respuesta Inmediata" }
        ].map((stat, index) => (
          <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }} className="text-center md:text-left border-l border-white/10 pl-6">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.num}</h3>
            <p className="text-yellow-400/80 text-sm uppercase tracking-wide font-semibold">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

const AboutSection = () => {
  return (
    <section id="nosotros" className="py-24 bg-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 skew-x-12 translate-x-20 z-0"></div>
        <div className="container mx-auto px-6 relative z-10">
            <div className="grid md:grid-cols-2 gap-16 items-center">
                <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                    <div className="flex items-center gap-4 mb-6">
                        <div className="h-px w-12 bg-yellow-400"></div>
                        <span className="text-slate-500 uppercase tracking-widest text-sm font-semibold">¿Quiénes Somos?</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8 leading-tight">
                        Aliados estratégicos en el suministro de <span className="text-yellow-500">energía.</span>
                    </h2>
                    <p className="text-slate-600 text-lg leading-relaxed mb-6">
                        Somos una empresa peruana con <strong>más de 24 años</strong> en el sector y cientos de clientes satisfechos. Diseñamos e implementamos soluciones integrales a la medida de la necesidad de nuestros clientes, generando valor real a sus negocios con tecnología de vanguardia.
                    </p>
                    <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-slate-900 mb-6">
                        <h4 className="font-bold text-slate-900 mb-2 flex items-center gap-2"><Zap size={18} className="text-yellow-500"/> Nuestra Misión</h4>
                        <p className="text-slate-600 text-sm">
                            Garantizar la continuidad, eficiencia y seguridad de las operaciones, comprometiéndonos con el desarrollo sostenible y la generación de valor en el norte y todo el Perú.
                        </p>
                    </div>
                </motion.div>
                <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative">
                    <div className="aspect-[4/5] bg-slate-200 overflow-hidden rounded-sm relative shadow-2xl">
                         <img src="https://aden.afygroup.net/foto1.jpg" alt="Equipo ADEN" className="w-full h-full object-cover grayscale-[30%] hover:grayscale-0 transition-all duration-700" />
                        <div className="absolute bottom-0 left-0 w-full p-8 bg-gradient-to-t from-slate-900/90 to-transparent">
                            <div className="flex items-center gap-4 text-white">
                                <ShieldCheck className="text-yellow-400" size={32} />
                                <div><span className="font-bold text-xl block">Cumplimiento Normativo</span><span className="text-sm text-slate-300">Estándares de calidad rigurosos</span></div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    </section>
  );
};

const DivisionsSection = () => {
    const [selectedDivision, setSelectedDivision] = useState(null);

    return (
        <section id="soluciones" className="py-24 bg-slate-900 text-white relative">
            <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-[#0B1120] z-0" />
            <div className="container mx-auto px-6 relative z-10">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="text-yellow-400 uppercase tracking-widest text-sm font-semibold mb-2 block">Nuestras Divisiones</span>
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">Soluciones Eléctricas Integrales</h2>
                    <div className="h-1 w-20 bg-white/10 mx-auto rounded-full"></div>
                </div>

                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {divisions.map((div, index) => (
                        <motion.div key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}
                            onClick={() => setSelectedDivision(div)}
                            className="group bg-slate-800/50 hover:bg-slate-800 border border-slate-700/50 hover:border-yellow-400/50 p-8 rounded-xl transition-all duration-300 flex flex-col h-full cursor-pointer relative overflow-hidden"
                        >
                            <div className="absolute top-4 right-4 bg-slate-700/50 p-2 rounded-full group-hover:bg-yellow-400 group-hover:text-slate-900 transition-colors">
                                <Plus size={16} />
                            </div>
                            <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6 group-hover:bg-yellow-400 transition-colors duration-300 shadow-lg">
                                <div.icon size={32} className="text-yellow-400 group-hover:text-slate-900 transition-colors duration-300" />
                            </div>
                            <h3 className="text-xl font-bold mb-4 text-white">{div.title}</h3>
                            <p className="text-slate-400 text-sm leading-relaxed flex-grow">{div.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Modal de Detalle */}
            <AnimatePresence>
                {selectedDivision && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setSelectedDivision(null)} className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm" />
                        <motion.div initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 20 }} className="relative bg-slate-900 border border-slate-700 w-full max-w-lg rounded-2xl shadow-2xl p-8 z-10">
                            <button onClick={() => setSelectedDivision(null)} className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors">
                                <XCircle size={28} />
                            </button>
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center text-slate-900">
                                    <selectedDivision.icon size={24} />
                                </div>
                                <h3 className="text-2xl font-bold text-white">{selectedDivision.title}</h3>
                            </div>
                            <p className="text-slate-300 mb-6 leading-relaxed border-b border-slate-700 pb-6">{selectedDivision.text}</p>
                            <ul className="space-y-4">
                                {selectedDivision.details.map((detail, idx) => (
                                    <li key={idx} className="flex items-start gap-3">
                                        <CheckCircle size={20} className="text-yellow-400 shrink-0 mt-0.5" />
                                        <span className="text-slate-300 text-sm leading-relaxed">{detail}</span>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </section>
    );
};

const RentalSection = () => {
    return (
        <section id="rental" className="py-24 bg-slate-50">
            <div className="container mx-auto px-6">
                 <div className="text-center max-w-3xl mx-auto mb-16">
                    <span className="text-slate-500 uppercase tracking-widest text-sm font-semibold mb-2 block">División Maquinaria</span>
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">Potencia cuando más lo necesita</h2>
                    <p className="text-slate-600 text-lg">No deje que un corte de energía o la falta de equipos detenga su operación. Contamos con disponibilidad inmediata de maquinaria de alta capacidad — <strong className="text-slate-800">lista para operar en cualquier punto del Perú, hoy mismo.</strong></p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {rentalItems.map((item, index) => (
                        <div key={index} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_40px_-15px_rgba(250,204,21,0.2)] hover:border-yellow-200 transition-all duration-300">
                            <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-6 text-slate-900 border border-slate-100">
                                <item.icon size={28} />
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                            <p className="text-slate-500 text-sm mb-6 leading-relaxed min-h-[60px]">{item.desc}</p>
                            <div className="space-y-3">
                                {item.specs.map((spec, i) => (
                                    <div key={i} className="flex items-center gap-2 text-sm text-slate-700 font-medium">
                                        <div className="w-1.5 h-1.5 rounded-full bg-yellow-500" />
                                        {spec}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

const ProjectsSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextProject = () => setCurrentIndex((prev) => (prev + 1) % projects.length);
    const prevProject = () => setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);

    return (
        <section id="proyectos" className="py-28 bg-white border-t border-slate-100">
            <div className="container mx-auto px-6">
                <div className="text-center mb-20">
                    <span className="text-slate-500 uppercase tracking-widest text-sm font-semibold mb-2 block">Portafolio Nacional</span>
                    <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4 tracking-tight">Proyectos de Gran Envergadura</h2>
                    <p className="text-slate-500 text-base max-w-2xl mx-auto mb-6">Más de dos décadas ejecutando obras eléctricas en alta, media y baja tensión a lo largo de todo el Perú. Cada proyecto es un testimonio de nuestra capacidad técnica y compromiso con la calidad.</p>
                    <div className="h-[2px] w-16 bg-yellow-400 mx-auto rounded-full"></div>
                </div>

                <div className="relative max-w-6xl mx-auto">
                    <div className="absolute top-1/2 -left-16 -translate-y-1/2 hidden xl:block z-20">
                         <button onClick={prevProject} className="w-14 h-14 rounded-full border border-slate-200 bg-white text-slate-400 hover:text-yellow-500 hover:border-yellow-400 hover:shadow-lg transition-all flex items-center justify-center">
                            <ChevronLeft size={24} strokeWidth={1.5} />
                        </button>
                    </div>
                    <div className="absolute top-1/2 -right-16 -translate-y-1/2 hidden xl:block z-20">
                         <button onClick={nextProject} className="w-14 h-14 rounded-full border border-slate-200 bg-white text-slate-400 hover:text-yellow-500 hover:border-yellow-400 hover:shadow-lg transition-all flex items-center justify-center">
                            <ChevronRight size={24} strokeWidth={1.5} />
                        </button>
                    </div>

                    <div className="bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] overflow-hidden min-h-[480px] flex relative border border-slate-100">
                        <AnimatePresence mode='wait'>
                            <motion.div key={currentIndex} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.4, ease: "easeInOut" }} className="w-full flex flex-col-reverse lg:flex-row">
                                <div className="lg:w-5/12 p-10 lg:p-14 flex flex-col justify-center relative">
                                    <div className="mb-6">
                                        <span className={`inline-block px-3 py-1 text-xs font-bold tracking-widest uppercase rounded-full border mb-4 
                                            ${projects[currentIndex].category === 'Contratos Ejecutados' ? 'bg-green-50 text-green-700 border-green-200' : 
                                              projects[currentIndex].category === 'Contratos en Ejecución' ? 'bg-yellow-50 text-yellow-700 border-yellow-200' : 
                                              'bg-blue-50 text-blue-700 border-blue-200'}`}>
                                            {projects[currentIndex].category}
                                        </span>
                                        <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-3 leading-tight tracking-tight">
                                            {projects[currentIndex].title}
                                        </h3>
                                        <div className="flex items-center gap-2 mb-4">
                                            <MapPin size={14} className="text-yellow-500 shrink-0" />
                                            <span className="text-xs text-slate-400 font-semibold uppercase tracking-wide">Perú — Ejecución Nacional</span>
                                        </div>
                                    </div>
                                    <p className="text-slate-500 leading-relaxed mb-6 text-sm border-l-2 border-yellow-400 pl-4">
                                        {projects[currentIndex].desc}
                                    </p>
                                    <div className="bg-slate-50 rounded-lg px-4 py-3 mb-6 flex items-center gap-3">
                                        <Zap size={16} className="text-yellow-500 shrink-0" />
                                        <p className="text-xs text-slate-600 leading-snug">Proyecto ejecutado bajo estrictos estándares del <strong>Código Nacional de Electricidad (CNE)</strong> y normativa MINEM vigente.</p>
                                    </div>
                                    <div className="flex gap-4 mt-auto lg:hidden justify-center border-t border-slate-100 pt-6">
                                        <button onClick={prevProject} className="p-3 border border-slate-200 rounded-full hover:bg-slate-50 transition-colors"><ChevronLeft size={20} className="text-slate-600"/></button>
                                        <span className="flex items-center text-sm font-bold text-slate-400">{currentIndex + 1} / {projects.length}</span>
                                        <button onClick={nextProject} className="p-3 border border-slate-200 rounded-full hover:bg-slate-50 transition-colors"><ChevronRight size={20} className="text-slate-600"/></button>
                                    </div>

                                    {/* Indicador para desktop */}
                                    <div className="hidden lg:flex items-center text-sm font-bold text-slate-300 mt-auto">
                                        Proyecto {currentIndex + 1} de {projects.length}
                                    </div>
                                </div>

                                <div className="lg:w-7/12 relative h-[300px] lg:h-auto overflow-hidden bg-slate-900">
                                    <video key={projects[currentIndex].video} src={projects[currentIndex].video} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover opacity-80" />
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </section>
    );
};

const ContactSection = () => {
    const form = useRef();
    const [status, setStatus] = useState('idle');

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus('sending');
        emailjs.sendForm('aden', 'template_iewvs39', form.current, 'IExxtTsnTjTV0WEew')
            .then(() => {
                setStatus('success');
                form.current.reset(); 
                setTimeout(() => setStatus('idle'), 5000);
            }, () => setStatus('error'));
    };

    return (
        <section id="contacto" className="py-24 bg-slate-900 text-white relative overflow-hidden">
             <div className="absolute inset-0 z-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle, #facc15 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
             <div className="container mx-auto px-6 relative z-10">
                <div className="grid md:grid-cols-2 gap-16">
                    <div>
                        <h2 className="text-4xl md:text-5xl font-bold mb-6">Asegure la operatividad de su <span className="text-yellow-400">proyecto.</span></h2>
                        <p className="text-slate-400 text-lg mb-10">
                            Desde diseño e implementación hasta rental de equipos de potencia. Nuestro equipo de ingeniería está listo para brindarle una cotización y respuesta inmediata.
                        </p>
                        <div className="space-y-6">
                            <div className="flex items-start gap-4">
                                <div className="p-3 bg-white/5 rounded-full text-yellow-400"><MapPin size={24} /></div>
                                <div><h4 className="font-bold text-lg">Oficina Central</h4><p className="text-slate-400">Los Tallanes Etapa 2, Mza. G Lote. 3</p></div>
                            </div>
                            <div className="flex items-start gap-4">
                                <div className="p-3 bg-white/5 rounded-full text-yellow-400"><Activity size={24} /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Contacto Directo</h4>
                                    <p className="text-slate-400">Teléfono: (073) 351755</p>
                                    <p className="text-slate-400">Celular: +51 908 892 254</p>
                                    <p className="text-slate-400 mt-1 font-medium text-yellow-400">ventas@adeneirl.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white p-8 md:p-10 rounded-xl text-slate-900 shadow-2xl">
                        <form ref={form} onSubmit={sendEmail} className="space-y-6">
                            <div className="grid md:grid-cols-2 gap-6">
                                <div><label className="block text-sm font-bold text-slate-700 mb-2">Nombre</label><input required name="user_name" type="text" className="w-full bg-slate-100 border border-slate-200 p-3 rounded-lg focus:outline-none focus:border-yellow-400 transition-colors" placeholder="Tu nombre" /></div>
                                <div><label className="block text-sm font-bold text-slate-700 mb-2">Empresa</label><input required name="user_company" type="text" className="w-full bg-slate-100 border border-slate-200 p-3 rounded-lg focus:outline-none focus:border-yellow-400 transition-colors" placeholder="Nombre empresa" /></div>
                            </div>
                            <div><label className="block text-sm font-bold text-slate-700 mb-2">Email</label><input required name="user_email" type="email" className="w-full bg-slate-100 border border-slate-200 p-3 rounded-lg focus:outline-none focus:border-yellow-400 transition-colors" placeholder="correo@empresa.com" /></div>
                            <div><label className="block text-sm font-bold text-slate-700 mb-2">Requerimiento</label><textarea required name="message" rows="4" className="w-full bg-slate-100 border border-slate-200 p-3 rounded-lg focus:outline-none focus:border-yellow-400 transition-colors" placeholder="Indique si requiere ejecución de obra, mantenimiento, o rental de equipos..."></textarea></div>
                            <button type="submit" disabled={status === 'sending' || status === 'success'} className={`w-full font-bold py-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 ${status === 'success' ? 'bg-green-600 text-white' : status === 'error' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white hover:bg-yellow-500 hover:text-slate-900'}`}>
                                {status === 'sending' && <Loader2 className="animate-spin" />}
                                {status === 'sending' && "Procesando..."}
                                {status === 'success' && <><CheckCircle /> Cotización Solicitada</>}
                                {status === 'error' && <><AlertCircle /> Error de sistema</>}
                                {status === 'idle' && "Solicitar Cotización"}
                            </button>
                        </form>
                    </div>
                </div>
             </div>
        </section>
    );
};

const Footer = () => {
    return (
        <footer className="bg-slate-950 text-white pt-20 pb-10 border-t border-white/10">
            <div className="container mx-auto px-6">
                <div className="grid md:grid-cols-4 gap-12 mb-16">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-2 mb-6"><img src="/logo-aden.png" alt="ADEN Logo" className="h-10 brightness-0 invert opacity-90" /></div>
                        <p className="text-slate-400 max-w-md mb-6 leading-relaxed">Soluciones integrales en ingeniería electromecánica y eléctrica. Garantizamos continuidad, eficiencia y seguridad operativa en todo el Perú.</p>
                        <div className="flex gap-4">
                            {[Instagram, Linkedin, Facebook].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-yellow-400 hover:text-slate-900 transition-all text-white"><Icon size={18} /></a>)}
                        </div>
                    </div>
                    <div>
                        <h4 className="font-bold text-lg mb-6">Navegación</h4>
                        <ul className="space-y-3 text-slate-400">
                            <li><a href="#soluciones" className="hover:text-yellow-400 transition-colors">Obras y Servicios</a></li>
                            <li><a href="#rental" className="hover:text-yellow-400 transition-colors">Rental de Maquinaria</a></li>
                            <li><a href="#proyectos" className="hover:text-yellow-400 transition-colors">Portafolio de Proyectos</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold text-lg mb-6">Contacto</h4>
                        <ul className="space-y-3 text-slate-400">
                            <li>proyectos@aden.pe</li>
                            <li>www.aden.pe</li>
                            <li>+51 908 892 254</li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
                    <p>&copy; {new Date().getFullYear()} Aden EIRL Todos los derechos reservados.</p>
                </div>
            </div>
        </footer>
    );
};

export default function App() {
  return (
    <div className="font-sans antialiased text-slate-800 bg-slate-50 selection:bg-yellow-400 selection:text-slate-900 overflow-x-hidden">
      <Navbar />
      <Hero />
      <Stats />
      <AboutSection />
      <DivisionsSection />
      <RentalSection />
      <ProjectsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}